import React, { useState, useEffect } from "react";
 
import { Scroll } from "../Scroll function/scroll";
import { ToggleMenu } from "./UserProfile";
import { BackToscreen } from "./Orders";
import { FaArrowLeft } from "react-icons/fa";
import "./help_and_support.css";
import upperContentImg from "./Assets/upperContentImg.svg";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
function Help_and_support() {

  useEffect(() => {
    Scroll()
  }, [])

  return (
    <div>
     <NewHeader />

      <div className="activeDashboard">
        <div className="dashboard_content">
        <div className="back_btn">
            {/* <Link to="/userdashboard">
              <FaArrowLeft /> Back to dashboard
            </Link> */}
          </div>
          <BackToscreen title="Help and Support" />

          <div className="flexparent">
            <div className="dashboard_contentLeft">
              <ToggleMenu isHelpAndSupport={true} />
            </div>
          
            <div className="dashboard_contentRight">
              <div className="dashboard_contentRight-contentBox upperContent">
                  <div className="upperContent_img">
                      <img src={ upperContentImg } alt="Profile Image" />
                  </div>
                  <div className="upperContent_text">
                      <h1>We're here to help!</h1>
                      <p>If you have any queries related to any of our tests or packages, you can contact us on the below mentioned phone number or email.</p>
                      <div className="contact_text">
                          <div className="contactDetails">
                              <p>Call</p>
                              <p className="redText"> <a href="tel:8988988787">898 898 8787</a></p>
                          </div>
                          <div className="contactDetails">
                              <p>Email</p>
                              <p className="redText"><a href="mailto:care@redcliffelabs.com"> care@redcliffelabs.com </a> </p>
                          </div>
                      </div>
                  </div>
              </div>
              {/* <h1 className="faqs">FAQs</h1>
              <div className="dashboard_contentRight-contentBox lowerContent">
                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default {
  component: Help_and_support,
};
